// extracted by mini-css-extract-plugin
export default {"authentication":"Authe_authentication__1RYBU","authFormWrpper":"Authe_authFormWrpper__5Jrqt","telegramBtn":"Authe_telegramBtn__ND86W"};